<script setup lang="ts">
import type { AudioClip } from '../api/types';
import ClipCard from './ClipCard.vue';

defineProps<{
  clips: AudioClip[];
  loading?: boolean;
}>();
</script>

<template>
  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
    <ClipCard
      v-for="(clip, index) in clips"
      :key="clip.id"
      :clip="clip"
      :pad-number="index + 1"
    />

    <!-- Loading skeletons -->
    <template v-if="loading">
      <div
        v-for="i in 4"
        :key="`skeleton-${i}`"
        class="bg-console-panel border border-console-border rounded-xl p-4 min-h-[130px] animate-pulse"
      >
        <div class="flex justify-between items-start mb-3">
          <div class="h-5 w-16 bg-slate-700 rounded"></div>
          <div class="h-5 w-5 bg-slate-700 rounded"></div>
        </div>
        <div class="h-4 bg-slate-700 rounded w-3/4 mb-2"></div>
        <div class="h-3 bg-slate-700 rounded w-1/2"></div>
        <div class="mt-auto pt-4 flex justify-between">
          <div class="flex gap-0.5">
            <div class="w-1 h-3 bg-slate-700 rounded-full"></div>
            <div class="w-1 h-5 bg-slate-700 rounded-full"></div>
            <div class="w-1 h-2 bg-slate-700 rounded-full"></div>
            <div class="w-1 h-4 bg-slate-700 rounded-full"></div>
          </div>
          <div class="h-3 w-8 bg-slate-700 rounded"></div>
        </div>
      </div>
    </template>
  </div>

  <!-- Empty State -->
  <div
    v-if="!loading && clips.length === 0"
    class="flex flex-col items-center justify-center py-20 text-center"
  >
    <span class="material-symbols-outlined text-6xl text-slate-600 mb-4">music_off</span>
    <h3 class="text-xl font-bold text-slate-400 mb-2">No clips found</h3>
    <p class="text-slate-500">Try adjusting your search or filters</p>
  </div>
</template>
